<template>
  <div class="mx-3 print-transfer-data">
    <div>
      <b-row>
        <b-col cols="12" class="print-transfer-only">
          <Logo background class="bg-white"></Logo>
        </b-col>
        <b-col cols="12" class="mt-4 print-transfer-only">
          {{ $t('form.summary.traditional.thanksForHelp') }}
        </b-col>
        <b-col offset-md="3" cols="12" md="9" class="text-lg font-weight-bold mt-4 mb-4">
          {{ $t('form.summary.traditional.bankDetails') }}
        </b-col>
      </b-row>
      <b-row v-for="(item, index) in bankTransferDetails" :key="index" class="mb-4">
        <b-col class="font-weight-bold" offset-md="3" cols="6" md="3">{{ item.label }}</b-col>
        <b-col cols="12" md="6" v-if="typeof item.content === 'string'">
          {{ item.content }}
        </b-col>
        <b-col cols="12" md="6" v-else>
          <p v-for="(item, index) in item.content" :key="index" class="mb-0">{{ item }}</p>
        </b-col>
      </b-row>
    </div>
    <div class="print-button" @click="print">
      <b-row>
        <b-col offset-md="6" cols="auto">
          <p class="mb-0 text-primary font-weight-bold text-md link-pointer">
            <b-icon-printer variant="primary" scale="1.5" class="mr-2"></b-icon-printer>
            {{ $t('form.summary.printButton') }}
          </p>
        </b-col>
      </b-row>
    </div>
    <div>
      <b-row>
        <b-col offset-md="3" cols="12" md="9" class="text-lg font-weight-bold mt-4 mb-4">
          {{ $t('form.summary.traditional.foreignBankDetails') }}
        </b-col>
      </b-row>
      <b-row v-for="(item, index) in foreignBankTransferDetails" :key="index" class="mb-4">
        <b-col class="font-weight-bold" offset-md="3" cols="6" md="3">{{ item.label }}</b-col>
        <b-col cols="12" md="6" v-if="typeof item.content === 'string'">
          {{ item.content }}
        </b-col>
        <b-col cols="12" md="6" v-else>
          <p v-for="(item, index) in item.content" :key="index" class="mb-0">{{ item }}</p>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { bankTransferDetails, foreignBankTransferDetails } from '@/constants/bankTransferDetails'
import Logo from '@/components/widgets/Logo.vue'

export default {
  name: 'BankTransferData',
  components: { Logo },
  props: {
    amount: [Number, null],
    order: {
      type: String
    }
  },
  data() {
    return {
      bankTransferDetails,
      foreignBankTransferDetails
    }
  },
  methods: {
    print() {
      window.print()
    }
  },
  created() {
    const amount = this.bankTransferDetails.find((el) => el.label.includes('Kwota'))
    if (amount) {
      amount.content = `${this.amount} ${this.$t('form.label.pln')}`
    }
    const title = this.bankTransferDetails.find((el) => el.label.includes('Tytułem'))
    if (title) {
      title.content = this.$t('form.summary.traditional.transferTitle', { donor: this.order })
    }
  }
}
</script>
